import { Image } from "react-bootstrap";
import Cookies from "js-cookie";
const expirationMinutes = process.env.REACT_APP_TOKEN_EXPIRATION || 60; // Default to 60 minutes if not set
const expirationDate = new Date(
    new Date().getTime() + expirationMinutes * 60000
);

const cookieOptionsProduction = {
  expires: expirationDate,
  secure: true,
  sameSite: "None",
  domain:process.env.REACT_APP_ALLOW_COOKIES
};

const cookieOptionsLocal = {
  expires: expirationDate,
  secure: true,
  sameSite: "Strict",
};

let cookieOptions=cookieOptionsProduction;
if(process.env.REACT_APP_MODE=="localhost")

  cookieOptions=cookieOptionsLocal;


// export function isTokenPresent() {
//   let token = localStorage.getItem("id_token");
//   //console_log('token',token);
//   if (token) return true;
//   return false;
// }
//
// export function getToken() {
//   let token = localStorage.getItem("id_token");
//   return token;
// }
//
// export function removeToken() {
//   localStorage.removeItem("id_token");
// }

export function setToken(token) {
  if (!token) return;

  // Cookies.set("id_token", "yourToken", { domain: ".yourdomain.com", expires: 1, sameSite: "Lax", secure: true });
  Cookies.set("id_token", token, cookieOptions);
}

export function getToken() {
  return Cookies.get("id_token") || null;
}

export function isTokenPresent() {
  return !!getToken();
}

export function removeToken() {
  Cookies.remove("id_token");
}

export function setLocalStorage(name, value) {
  localStorage.setItem(name, value);
}

export function getLocalStorage(name) {
  return localStorage.getItem(name);
}

export function removeLocalStorage(name, value) {
  localStorage.removeItem(name, value);
}

export function setCookie(name, value) {


  console.log('cookieOptions',cookieOptions);
  Cookies.set(name, value, cookieOptions);
}

// Get a cookie value
export function getCookie(name) {
  return Cookies.get(name) || null;
}

// Remove a cookie
export function removeCookie(name) {
  Cookies.remove(name);
}

export function userImageRender(image = null, name = null) {
  // console_log('name',name);
  if (image) return <Image src={image} className="me-1 image-avatar" />;
  return (
      <div className="no-image-avatar">
        {name ? getInitials(name).toUpperCase() : ""}
      </div>
  );
}

function getInitials(name) {
  if (!name) return ""; // Handle empty or undefined names

  let words = name.trim().split(/\s+/);
  return words.length > 1
      ? (words[0][0] + words[1][0]).toUpperCase()
      : words[0][0].toUpperCase();
}
